export const SIDE_MENU = {
  my_eqp: {
    name: 'MY_EQP',
    label: 'SIS_EQUIP_LIST',
    is_active: true,
    tab_id: 0,
    ga_event_name: 'e_facetNav',
    ga_nltext: 'My Equipment',
    ga_context: 'Homepage Menu'
  },
  service_insights: {
    name: 'SERVICE_RECOMMENDATIONS',
    label: 'SERVICE_RECOMMENDATIONS',
    is_active: false,
    tab_id: 1,
    ga_event_name: 'e_facetNav',
    ga_nltext: 'service recommendations',
    ga_context: 'Homepage Menu'
  },
  recently_viewd: {
    name: 'RECENTLY_VIEWED',
    label: 'RECENTLY_VIEWED',
    is_active: false,
    tab_id: 2,
    ga_event_name: 'e_facetNav',
    ga_nltext: 'recent orders',
    ga_context: 'Homepage Menu'
  },
  bug_again: {
    name: 'HOMEPAGE_BUY_AGAIN',
    label: 'HOMEPAGE_BUY_AGAIN',
    is_active: false,
    tab_id: 3,
    ga_event_name: 'e_facetNav',
    ga_nltext: 'buy again',
    ga_context: 'Homepage Menu'
  }
};

export const TAB_ID = {
  MODEL: 'model',
  SERIAL: 'serial'
};

export const NoRecentViewImage = {
  imgUrl:
    'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240509-e4f4b-92c32?hei=120&wid=180'
};
export const ERROR_IMAGE = {
  imgUrl:
    'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240523-b8387-22a51?&fmt=webp&wid=180&hei=109',
  alt: 'error image'
};
export const FORM_FIELD_SERIAL = 'serial';
export const EQUIPMENT_METHOD = {
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  SELECT: 'select'
};
export const PRODUCT_LIST_LIMIT = 2;
export const ERROR = 'error';
export const EQUIPMENT_LIST_LIMIT = 25;

export const QUICK_ACTIONS_GA = {
  VIEW_DASHBOARD: 'View Dashboard',
  SHOP_PARTS: 'Shop parts',
  CAT_PARTS_DIAGRAM: 'Parts Diagram',
  ALP_MAINTENANCE_REPAIRS: 'maintenance and repairs',
  CLEAR_SELECTION: 'clear selection',
  EDIT: 'edit',
  REQUEST_SERVICE: 'request service',
  DELETE: 'delete',
  MORE: 'more menu options'
};

export const GA_LOCATION_FOR_CA = 'PCC Home Page';
export const GA_FORM_NAME_BY_SERIAL = 'By Serial Number | add equipment';
export const GA_FORM_NAME_BY_MODEL = 'By Model | add equipment';

export const PRODUCT_LIST_BUY_AGAIN_SIZE = 20;
